export const ME_REQUEST = 'ME_REQUEST'
export const ME_SUCCESS = 'ME_SUCCESS'
export const ME_ERROR = 'ME_ERROR'
export const SET_FCM_TOKEN = "SET_FCM_TOKEN";
export const SET_TOKEN = 'SET_TOKEN'
export const SIGN_OUT = 'SIGN_OUT'

export const UPDATE_NOTIFICATION_COUNT = "UPDATE_NOTIFICATION_COUNT";
export const UPDATE_NOTIFICATION_COUNT_SUCCESS = "UPDATE_NOTIFICATION_COUNT_SUCCESS";
export const UPDATE_NOTIFICATION_COUNT_FAILURE = "UPDATE_NOTIFICATION_COUNT_FAILURE";